import React from 'react';
import { ExclamationCircleOutlined } from '@ant-design/icons';

import {
    VMIcon,
    CaretDownIcon,
    CaretUpIcon,
    CpuIcon,
    RamIcon,
    CheckmarkIcon,
    StorageIcon,
} from '../../components/icons';

import { MigrateIcon } from '../../components/icons/nav';

import { UtilizationInventoryCard } from './InventoryCard';
import { SummaryDetailsCard } from './SummaryDetailsCard/SummaryDetailsCard';
import { TopTenOpportunitiesCard } from './TopTenOpportunitiesCard/TopTenOpportunitiesCard';
import { ProjectDetailsCard } from './ProjectDetailsCard/ProjectDetailsCard';
import { SourcesCard } from './SourcesCard/SourcesCard';
import { MigrationStatusCard } from './MigrationStatusCard/MigrationStatusCard';
import { RMCard } from './RMCard';
import { CARD_TYPES } from './cardTypes';
import { MigrationAppliancesCard } from './MigrationAppliancesCard/MigrationAppliancesCard';

const getCardComponent = (cardType) => {
    switch (cardType) {
        case CARD_TYPES.UTILIZATION:
            return UtilizationInventoryCard;
        case CARD_TYPES.DETAILS:
            return SummaryDetailsCard;
        case CARD_TYPES.TOP_TEN_OPPORTUNITIES:
            return TopTenOpportunitiesCard;
        case CARD_TYPES.PROJECT_DETAILS:
            return ProjectDetailsCard;
        case CARD_TYPES.STAT:
            return SourcesCard;
        case CARD_TYPES.MIGRATION_STATUS:
            return MigrationStatusCard;
        case CARD_TYPES.MIGRATION_APPLIANCES:
            return MigrationAppliancesCard;
        default:
            return RMCard;
    }
};

const getIconComponent = (iconName) => {
    switch (iconName) {
        case 'vm':
            return VMIcon;
        case 'check':
            return CheckmarkIcon;
        case 'oversized':
            return CaretUpIcon;
        case 'undersized':
            return CaretDownIcon;
        case 'cpu':
            return CpuIcon;
        case 'ram':
            return RamIcon;
        case 'storage':
            return StorageIcon;
        case 'migrate':
            return MigrateIcon;
        default:
            return ExclamationCircleOutlined;
    }
};

const mapCardIcons = (cardType, props) => {
    const mappedProps = { ...props };

    if (cardType === CARD_TYPES.UTILIZATION) {
        const SubLabelIcon = getIconComponent(mappedProps.subLabelIcon);
        if (SubLabelIcon) {
            mappedProps.subLabelIcon = <SubLabelIcon appIconSmall />;
        }

        mappedProps.rows = mappedProps.rows?.map((row) => {
            const RowIcon = getIconComponent(row.icon);
            return {
                ...row,
                icon: RowIcon ? <RowIcon appIconSmall /> : row.icon,
            };
        });
    }
    return mappedProps;
};

export const buildCards = (configs, context, handlers) =>
    configs.map((config) => {
        const parsedData = config.parseResponse(context);
        return { id: config.id, cardType: config.cardType, ...config.values(parsedData, handlers) };
    });

export const SummaryCardRenderer = ({ cards, queryState: globalQueryState, ...restProps }) => {
    return (
        <>
            {cards.map(({ id, cardType, queryState: cardQueryState, ...cardProps }) => {
                const CardComponent = getCardComponent(cardType);
                const mappedProps = mapCardIcons(cardType, cardProps);
                const effectiveQueryState = cardQueryState ?? globalQueryState ?? {};
                return <CardComponent key={id} {...mappedProps} {...restProps} queryState={effectiveQueryState} />;
            })}
        </>
    );
};
